import React, {Component} from 'react';
import {connect} from 'react-redux';

import "../../assets/css/spinkit.css";

class ReduxLoader extends Component {
    render() {
        const spin = !!this.props.spin;
        return (
            <div className="wrapper">
                {
                    this.props.isLoading ? (
                        <div>
                            {
                                spin ? (
                                    <div className={"sk-circle"}>
                                        <div className="sk-circle1 sk-child"></div>
                                        <div className="sk-circle2 sk-child"></div>
                                        <div className="sk-circle3 sk-child"></div>
                                        <div className="sk-circle4 sk-child"></div>
                                        <div className="sk-circle5 sk-child"></div>
                                        <div className="sk-circle6 sk-child"></div>
                                        <div className="sk-circle7 sk-child"></div>
                                        <div className="sk-circle8 sk-child"></div>
                                        <div className="sk-circle9 sk-child"></div>
                                        <div className="sk-circle10 sk-child"></div>
                                        <div className="sk-circle11 sk-child"></div>
                                        <div className="sk-circle12 sk-child"></div>
                                    </div>
                                ) : (
                                    <div className={"sk-folding-cube"}>
                                        <div className="sk-cube1 sk-cube"></div>
                                        <div className="sk-cube2 sk-cube"></div>
                                        <div className="sk-cube4 sk-cube"></div>
                                        <div className="sk-cube3 sk-cube"></div>
                                    </div>
                                )
                            }
                        </div>
                    ) :
                        (
                            <div className="wrapper">
                                {this.props.children}
                            </div>
                        )
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    isLoading: state.display.isLoading
});

export default connect(mapStateToProps)(ReduxLoader);


// WEBPACK FOOTER //
// ./src/components/display/ReduxLoader.js